/**
 * The words for each kind of drop (moved out of text-policy, 19/10/2026):
 * a short label for the rows, the long words for the hints.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenDropKind } from "../text-policy";

/** Short labels for the rows; the long words live in the hints. */
export const DROP_GEN_DROP_KIND_WORDS: Record<DropGenDropKind, string> = {
  ROUTE_TEST: "route test drop",
  HIT_AGAIN: "hit-again drop",
  RETURNING: "returning list, test day",
  NEW_LIST: "list's first day",
  EXPERIMENT: "experiment drop",
  SCALED: "scaled drop",
  SHRUNK: "shrunk drop",
  PROBE: "probe hour",
  EXTRA: "Hour Optimizer extra",
  NORMAL: "ordinary drop",
};

export const DROP_GEN_DROP_KIND_HINTS: Record<DropGenDropKind, string> = {
  ROUTE_TEST:
    "A drop of the route test, which compares gateways and senders. Every test drop of the day sends the same texts, so only the gateway changes — the best of the text ranking by default (the route test's Creative tab).",
  HIT_AGAIN:
    "Sent right after a drop hit the Hit again rule (Verdicts › Hit again): the same list and gateway as the drop that hit, the amount the action set. It keeps the texts of the drop that hit unless you give it new texts here (★ proven + ✦ AI).",
  RETURNING: "A list back from a burn after its rest days — its one test day with the test amount. A FAIL burns it again.",
  NEW_LIST: "A list tagged New (first seen in the last days — Tag Rules › Lists) that this container's group had never sent to before today: the first drops on a new list.",
  EXPERIMENT: "A drop the running experiment reserved for the gateway under test (Gateways › Experiment).",
  SCALED: "The list is performing: a scaling step raised this drop's amount — a bigger stake.",
  SHRUNK: "The list is weak: a scaling step lowered this drop's amount.",
  PROBE: "An Hour Optimizer drop into an hour with too little data to rank, placed to learn.",
  EXTRA: "An extra drop the Hour Optimizer added in one of the best-ranked hours.",
  NORMAL: "A drop of the plain schedule — none of the above.",
};
